import { clientTranslator } from '@adornis/translation-core/client/clientTranslator.js';
import { ValidationError } from '@adornis/validation/errors/ValidationError.js';
import type { ValidationFunction } from '@adornis/validation/validator.js';

export const digitsOnly =
  (props?: { translationKey?: string; allowFalsy?: boolean }): ValidationFunction<any, any> =>
  options => {
    if (!props?.allowFalsy && !options.value) return;
    if (options.value && !/^\d+$/.test(options.value))
      throw new ValidationError(
        `Wert des Feldes "${clientTranslator.translate('field', options.key) as string}" darf nur Ziffern enthalten!`,
        {
          key: options.key,
          translationKey: props?.translationKey,
          path: options.path,
        },
      );
  };
